import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd047aService,
  Sgkd047aRequest,
  Sgkd047aResponse,
  Sgkd047aMshkmInfoListDto,
  Sgkd047aFubiReasonCodeDto
} from 'sg-api';
import { Sgkd020dPrintInfo } from '../models/skgd020d-print_info';
import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';

/** 不備理由テーブル選択行の種別・コードペア */
export interface HubirsnItem {
  /** 不備理由種別 */
  clsfy: string;
  /** 不備理由コード */
  code: string;
}

responseType: 'blob'

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dSgkd047aService {

  private _rsesult$ = new Subject<Sgkd047aResponse>();
  doSgkd047a: any;

  constructor(
    private sgkd047aService: Sgkd047aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    print(printInfo: Sgkd020dPrintInfo, searchInfo: any, hubirsnList: HubirsnItem[]): Observable<Sgkd047aResponse> {
    
      let fubiReason: string = "";
      let ctrName: string = "";
      let postNo: string = "";
      let pfcAName: string = "";
      let admnCwNm: string = "";
      let admnTNm: string = "";
      let oazaAName: string = "";
      let bgou: string = "";
      let tatemnName: string = "";
      let aimRoomNo: string = "";

      let mshkmInfoList: Sgkd047aMshkmInfoListDto = {};

      fubiReason = "";
      ctrName = "";
      postNo = "";
      pfcAName = "";
      admnCwNm = "";
      admnTNm = "";
      oazaAName = "";
      bgou = "";
      tatemnName = "";
      aimRoomNo = "";

      // 不備理由種別・コードを最大26件セット
      hubirsnList.slice(0, 26).forEach((item, i) => {

        fubiReason = item.clsfy;    

        if (item.clsfy == SgKdConstants.CODE.REQDOC_FUBI_KIND_CODE.USER_CODE.SG_BIZ_FUBI ||
            item.clsfy == SgKdConstants.CODE.CARD_FUBI_KIND_CODE.USER_CODE.SG_BIZ_FUBI) {

          if ((item.clsfy == SgKdConstants.CODE.REQDOC_FUBI_KIND_CODE.USER_CODE.SG_BIZ_FUBI && 
                item.code == SgKdConstants.CODE.REQDOC_FUBI_CODE.USER_CODE.CUST_NAME_MISS) || 
             (item.clsfy == SgKdConstants.CODE.CARD_FUBI_KIND_CODE.USER_CODE.SG_BIZ_FUBI && 
                item.code == SgKdConstants.CODE.CARD_FUBI_CODE.USER_CODE.NAMR_MISS))
          {
            ctrName = searchInfo.ctrerMei;
          }  

          if ((item.clsfy == SgKdConstants.CODE.REQDOC_FUBI_KIND_CODE.USER_CODE.SG_BIZ_FUBI &&
                 item.code != SgKdConstants.CODE.REQDOC_FUBI_CODE.USER_CODE.CUST_NAME_MISS) ||
              (item.clsfy == SgKdConstants.CODE.CARD_FUBI_KIND_CODE.USER_CODE.SG_BIZ_FUBI && 
                item.code != SgKdConstants.CODE.CARD_FUBI_CODE.USER_CODE.NAMR_MISS))
          {
            postNo      = searchInfo.postno;
            pfcAName    = searchInfo.prefectureaname;
            admnCwNm    = searchInfo.administrativecitywardname;
            admnTNm     = searchInfo.choname;
            oazaAName   = searchInfo.chome;
            bgou        = searchInfo.buildingnumber;
            tatemnName  = searchInfo.visitSupadrAname;
            aimRoomNo   = searchInfo.visitYagouAname;
          }
        }    
      });

      mshkmInfoList = {
        ctrName: ctrName, 
        postNo: postNo, 
        pfcAName: pfcAName, 
        admnCwNm: admnCwNm,
        admnTNm: admnTNm, 
        oazaAName: oazaAName, 
        bgou: bgou, 
        tatemnName:tatemnName, 
        aimRoomNo: aimRoomNo
      };
      
      let dtoList: Sgkd047aFubiReasonCodeDto[] = [];
      hubirsnList.slice(0, 26).forEach(item => {
        dtoList.push({
          fubiReasonCode: item.code
        });
      });

      // リクエスト生成
      let request: Sgkd047aRequest = {
        requestDto: {
          /** 申込書種別コード */
          srndocClsCode:    printInfo.srndocClsCode,
          /** 契約お客さま番号 */
          firstSrvctrNo:    printInfo.firstSrvctrNo,
          /** 不備理由種別 */
          fubiReason:       fubiReason,
          /** 不備理由コード */
          fubiReasonCodeList: dtoList, 
          /** 預金者名義相違 */
          dptprsDiff:       searchInfo.dptprsMeigiDiff,
          /** その他理由不備 */
          othDiff:          searchInfo.etcHubirsn,
          /** 申込情報リスト */  
          mshkmInfoList:    mshkmInfoList 
        }
      }
      
      return this.sgkd047aService.doSGKD047APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // コンテントタイプを取得
          const contentType = response.headers.get('Content-Type');

          if (contentType === 'application/octet-stream') {
            // ファイルが取得できた場合

            const fileBlob = new Blob([response.body], { type: contentType });
            const contentDisposition: string = response.headers.get('Content-Disposition');
            // 正規表現を使って、文字列からファイル名の抽出
            const matchesFileName: RegExpExecArray = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            // matchesFileName[1] に含まれるクォーテーション（' または "）をすべて削除しています
            const fileName: string = matchesFileName[1].replace(/['"]/g, '');
            // ヘッダ名「file-name」だった場合
            const fileNameDecode: string = decodeURIComponent(fileName);
            // ファイルとしてダウンロード
            this.anchorDownload(fileBlob, fileNameDecode, document);
            return response.body;
          } else if (this.sgkd047aService.configuration.isJsonMime(contentType)) {
            // JSONとして処理
            const textDecoder = new TextDecoder('utf-8');
            // ArrayBufferを文字列に変換
            const jsonString = textDecoder.decode(response.body);
            // JSONオブジェクトに変換
            const jsonResponse = JSON.parse(jsonString); 
            this.apiCommonService.checkError(response.clone({ body: jsonResponse }));
            return response.body;
          }
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD047A');
          return throwError(err.message);
        }
      )
    );
  }

  /**
   * 渡されたBlobオブジェクトとファイル名を元に内部でAnchor要素を作成し、
   * ブラウザ上でファイルとしてダウンロードする
   * @param {Blob} response
   * @param {string} filename
   * @param {Document} document
   * @memberof UsedSgkd019dSgkd001aService
   */
  anchorDownload(response: Blob, filename: string, document: Document): void {
    // 取得した情報をアンカー要素のURLに指定
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(response);
    // ダウンロード属性を指定して、ファイルとしてダウンロードするように指定
    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    // アンカー要素をクリックしてダウンロード
    downloadLink.click();
    // 追加した要素を削除
    document.body.removeChild(downloadLink);
  }
}
